import ButtonPrimary from '../Button/ButtonPrimary';
import Input from '../Input/Input';

const Subscribe = () => {
  return (
    <div className="items-stretch justify-between space-y-5 rounded-2xl p-5 md:flex md:space-y-0" style={{backgroundColor: '#ffffff1a'}} >
      <div className="basis-[52%] space-y-5">
        <h3 className="text-2xl font-medium">¿Quieres ser el primero en conocer nuestras novedades?</h3>
        <Input
          type="text"
          sizeClass="h-12 px-0 py-3"
          rounded="rounded-none"
          className="border-b-2 border-transparent border-b-neutral-400 bg-transparent placeholder:text-sm placeholder:text-neutral-500 focus:border-transparent text-black"
          placeholder="@email.com"
        />
      </div>
      <div className="basis-[43%] space-y-7">
        <p className="text-neutral-400">Déjanos tu correo y recibe las mejores ofertas y novedades de Capacut3D.</p>
        <ButtonPrimary className={"px-4i"} ariaLabel='Suscribete a nuestro Newsletter'>Subscribe</ButtonPrimary>
      </div>
    </div>
  );
};

export default Subscribe;
